// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchByCategpry_searchContainer__Tp1ml {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  direction: rtl;
  font-family: 'Arial', sans-serif;
}

/* Loading State */
.SearchByCategpry_loadingState__n6OGo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.SearchByCategpry_spinner__twS8g {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #1a5f3f;
  border-radius: 50%;
  animation: SearchByCategpry_spin__\\+hPwi 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes SearchByCategpry_spin__\\+hPwi {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Error State */
.SearchByCategpry_errorState__CNoV1 {
  background: #fee2e2;
  border: 2px solid #fca5a5;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  color: #dc2626;
  margin: 40px 0;
}

.SearchByCategpry_errorIcon__6NTib {
  font-size: 48px;
  margin-bottom: 16px;
}

.SearchByCategpry_errorState__CNoV1 h2 {
  font-size: 22px;
  margin: 0 0 12px 0;
  font-weight: 700;
}

.SearchByCategpry_errorState__CNoV1 p {
  font-size: 16px;
  margin: 0 0 20px 0;
}

.SearchByCategpry_retryButton__P4GLJ {
  background: #1a5f3f;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease;
}

.SearchByCategpry_retryButton__P4GLJ:hover {
  background: #0f4229;
}

/* Search Header */
.SearchByCategpry_searchHeader__46dwL {
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
}

.SearchByCategpry_backButton__7vTbh {
  background: transparent;
  border: 2px solid #1a5f3f;
  color: #1a5f3f;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.SearchByCategpry_backButton__7vTbh:hover {
  background: #1a5f3f;
  color: white;
}

.SearchByCategpry_backArrow__59YAv {
  font-size: 16px;
}

.SearchByCategpry_searchTitle__G2PDV {
  font-size: 24px;
  color: #1a202c;
  margin: 0 0 10px 0;
  font-weight: 700;
}

.SearchByCategpry_categoryName__KfOQO {
  background: rgba(26, 95, 63, 0.1);
  padding: 4px 12px;
  border-radius: 6px;
  font-weight: 600;
}

.SearchByCategpry_searchSubtitle__IPlvU {
  font-size: 16px;
  color: #64748b;
  margin-bottom: 8px;
}

.SearchByCategpry_searchTerm__wfVY7 {
  color: #1a5f3f;
  background: rgba(26, 95, 63, 0.1);
  padding: 4px 12px;
  border-radius: 6px;
  font-weight: 600;
}

.SearchByCategpry_resultsCount__3Wf6y {
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
}

/* No Results */
.SearchByCategpry_noResults__UJRAW {
  text-align: center;
  padding: 80px 20px;
  color: #64748b;
}

.SearchByCategpry_noResultsIcon__fivxI {
  font-size: 64px;
  margin-bottom: 20px;
}

.SearchByCategpry_noResults__UJRAW h3 {
  font-size: 20px;
  color: #374151;
  margin: 0 0 12px 0;
}

.SearchByCategpry_noResults__UJRAW p {
  font-size: 16px;
  margin: 0 0 24px 0;
}

.SearchByCategpry_allCategoriesButton__XojPH {
  background: #1a5f3f;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease;
}

.SearchByCategpry_allCategoriesButton__XojPH:hover {
  background: #0f4229;
}

/* Results Section */
.SearchByCategpry_resultsSection__FdKlU {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

/* Category Header */
.SearchByCategpry_categoryHeader__wQzs8 {
  margin-bottom: 30px;
}

.SearchByCategpry_categoryTitle__3-vwG {
  display: flex;
  align-items: center;
  gap: 12px;
}

.SearchByCategpry_categoryIcon__8xS6q {
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 6px;
}

.SearchByCategpry_categoryTitle__3-vwG h2 {
  font-size: 22px;
  font-weight: 700;
  margin: 0;
}

.SearchByCategpry_categoryCount__2KB8l {
  background: rgba(0, 0, 0, 0.1);
  color: #64748b;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.SearchByCategpry_postsGrid__kHktd {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

/* Post Cards */
.SearchByCategpry_postCard__uBJQ9 {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.SearchByCategpry_postCard__uBJQ9:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border-color: var(--category-color);
}

.SearchByCategpry_postImageContainer__dyvLv {
  position: relative;
  width: 100%;
  height: 160px;
  overflow: hidden;
}

.SearchByCategpry_postImage__suuht {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.SearchByCategpry_postCard__uBJQ9:hover .SearchByCategpry_postImage__suuht {
  transform: scale(1.05);
}

.SearchByCategpry_postOverlay__5dliS {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  padding: 6px;
  backdrop-filter: blur(4px);
}

.SearchByCategpry_postIcon__MzfQ0 {
  width: 20px;
  height: 20px;
  object-fit: cover;
}

/* Post Content */
.SearchByCategpry_postContent__tr\\+8q {
  padding: 20px;
}

.SearchByCategpry_postTitle__CdDKm {
  font-size: 16px;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 12px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.SearchByCategpry_postMeta__L7ao4 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  font-size: 12px;
  color: #64748b;
}

.SearchByCategpry_postAuthor__jrrX2 {
  font-weight: 600;
}

.SearchByCategpry_metaSeparator__k2F2i {
  color: #cbd5e1;
}

.SearchByCategpry_postDate__UnsCU {
  font-weight: 500;
}

.SearchByCategpry_postCategory__GcPLl {
  display: flex;
  justify-content: flex-end;
}

.SearchByCategpry_categoryBadge__auWHg {
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
}

/* Load More Section */
.SearchByCategpry_loadMoreSection__R5a-g {
  text-align: center;
  margin-top: 40px;
  padding: 30px;
}

.SearchByCategpry_loadMoreButton__-1qLv {
  color: white;
  border: none;
  border-radius: 14px;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(26, 95, 63, 0.3);
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.SearchByCategpry_loadMoreButton__-1qLv:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.4);
}

.SearchByCategpry_loadMoreArrow__pC4Ku {
  font-size: 14px;
}

.SearchByCategpry_loadMoreCount__8OXce {
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  background: rgba(26, 95, 63, 0.1);
  padding: 8px 16px;
  border-radius: 20px;
  display: inline-block;
}

/* Responsive  */
@media (max-width: 768px) {
  .SearchByCategpry_searchContainer__Tp1ml {
    padding: 15px;
  }

  .SearchByCategpry_postsGrid__kHktd {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 16px;
  }

  .SearchByCategpry_searchTitle__G2PDV {
    font-size: 20px;
  }

  .SearchByCategpry_categoryTitle__3-vwG h2 {
    font-size: 18px;
  }

  .SearchByCategpry_categoryHeader__wQzs8 {
    margin-bottom: 20px;
  }

  .SearchByCategpry_loadMoreSection__R5a-g {
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .SearchByCategpry_postsGrid__kHktd {
    grid-template-columns: 1fr;
  }

  .SearchByCategpry_searchTitle__G2PDV {
    font-size: 18px;
  }

  .SearchByCategpry_categoryTitle__3-vwG {
    flex-wrap: wrap;
    gap: 8px;
  }

  .SearchByCategpry_postImageContainer__dyvLv {
    height: 140px;
  }

  .SearchByCategpry_postContent__tr\\+8q {
    padding: 16px;
  }

  .SearchByCategpry_backButton__7vTbh {
    width: 100%;
    justify-content: center;
  }

  .SearchByCategpry_loadMoreButton__-1qLv {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Search bars/SearchByCategpry.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,cAAc;EACd,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,2DAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE;IACE,aAAa;EACf;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".searchContainer {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  direction: rtl;\r\n  font-family: 'Arial', sans-serif;\r\n}\r\n\r\n/* Loading State */\r\n.loadingState {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 60px 20px;\r\n  text-align: center;\r\n}\r\n\r\n.spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 4px solid #f3f3f3;\r\n  border-top: 4px solid #1a5f3f;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n/* Error State */\r\n.errorState {\r\n  background: #fee2e2;\r\n  border: 2px solid #fca5a5;\r\n  border-radius: 12px;\r\n  padding: 40px;\r\n  text-align: center;\r\n  color: #dc2626;\r\n  margin: 40px 0;\r\n}\r\n\r\n.errorIcon {\r\n  font-size: 48px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.errorState h2 {\r\n  font-size: 22px;\r\n  margin: 0 0 12px 0;\r\n  font-weight: 700;\r\n}\r\n\r\n.errorState p {\r\n  font-size: 16px;\r\n  margin: 0 0 20px 0;\r\n}\r\n\r\n.retryButton {\r\n  background: #1a5f3f;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  padding: 12px 24px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.3s ease;\r\n}\r\n\r\n.retryButton:hover {\r\n  background: #0f4229;\r\n}\r\n\r\n/* Search Header */\r\n.searchHeader {\r\n  margin-bottom: 40px;\r\n  padding-bottom: 20px;\r\n  border-bottom: 2px solid #f0f0f0;\r\n}\r\n\r\n.backButton {\r\n  background: transparent;\r\n  border: 2px solid #1a5f3f;\r\n  color: #1a5f3f;\r\n  padding: 8px 16px;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  margin-bottom: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.backButton:hover {\r\n  background: #1a5f3f;\r\n  color: white;\r\n}\r\n\r\n.backArrow {\r\n  font-size: 16px;\r\n}\r\n\r\n.searchTitle {\r\n  font-size: 24px;\r\n  color: #1a202c;\r\n  margin: 0 0 10px 0;\r\n  font-weight: 700;\r\n}\r\n\r\n.categoryName {\r\n  background: rgba(26, 95, 63, 0.1);\r\n  padding: 4px 12px;\r\n  border-radius: 6px;\r\n  font-weight: 600;\r\n}\r\n\r\n.searchSubtitle {\r\n  font-size: 16px;\r\n  color: #64748b;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.searchTerm {\r\n  color: #1a5f3f;\r\n  background: rgba(26, 95, 63, 0.1);\r\n  padding: 4px 12px;\r\n  border-radius: 6px;\r\n  font-weight: 600;\r\n}\r\n\r\n.resultsCount {\r\n  color: #64748b;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n\r\n/* No Results */\r\n.noResults {\r\n  text-align: center;\r\n  padding: 80px 20px;\r\n  color: #64748b;\r\n}\r\n\r\n.noResultsIcon {\r\n  font-size: 64px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.noResults h3 {\r\n  font-size: 20px;\r\n  color: #374151;\r\n  margin: 0 0 12px 0;\r\n}\r\n\r\n.noResults p {\r\n  font-size: 16px;\r\n  margin: 0 0 24px 0;\r\n}\r\n\r\n.allCategoriesButton {\r\n  background: #1a5f3f;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  padding: 12px 24px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.3s ease;\r\n}\r\n\r\n.allCategoriesButton:hover {\r\n  background: #0f4229;\r\n}\r\n\r\n/* Results Section */\r\n.resultsSection {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 30px;\r\n}\r\n\r\n/* Category Header */\r\n.categoryHeader {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.categoryTitle {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.categoryIcon {\r\n  width: 32px;\r\n  height: 32px;\r\n  object-fit: cover;\r\n  border-radius: 6px;\r\n}\r\n\r\n.categoryTitle h2 {\r\n  font-size: 22px;\r\n  font-weight: 700;\r\n  margin: 0;\r\n}\r\n\r\n.categoryCount {\r\n  background: rgba(0, 0, 0, 0.1);\r\n  color: #64748b;\r\n  padding: 4px 8px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.postsGrid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 20px;\r\n}\r\n\r\n/* Post Cards */\r\n.postCard {\r\n  background: white;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  border: 2px solid transparent;\r\n}\r\n\r\n.postCard:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\r\n  border-color: var(--category-color);\r\n}\r\n\r\n.postImageContainer {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 160px;\r\n  overflow: hidden;\r\n}\r\n\r\n.postImage {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.postCard:hover .postImage {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.postOverlay {\r\n  position: absolute;\r\n  top: 12px;\r\n  right: 12px;\r\n  background: rgba(255, 255, 255, 0.9);\r\n  border-radius: 8px;\r\n  padding: 6px;\r\n  backdrop-filter: blur(4px);\r\n}\r\n\r\n.postIcon {\r\n  width: 20px;\r\n  height: 20px;\r\n  object-fit: cover;\r\n}\r\n\r\n/* Post Content */\r\n.postContent {\r\n  padding: 20px;\r\n}\r\n\r\n.postTitle {\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  color: #1a202c;\r\n  margin: 0 0 12px 0;\r\n  line-height: 1.4;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n\r\n.postMeta {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 16px;\r\n  font-size: 12px;\r\n  color: #64748b;\r\n}\r\n\r\n.postAuthor {\r\n  font-weight: 600;\r\n}\r\n\r\n.metaSeparator {\r\n  color: #cbd5e1;\r\n}\r\n\r\n.postDate {\r\n  font-weight: 500;\r\n}\r\n\r\n.postCategory {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.categoryBadge {\r\n  color: white;\r\n  padding: 4px 12px;\r\n  border-radius: 16px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  text-align: center;\r\n}\r\n\r\n/* Load More Section */\r\n.loadMoreSection {\r\n  text-align: center;\r\n  margin-top: 40px;\r\n  padding: 30px;\r\n}\r\n\r\n.loadMoreButton {\r\n  color: white;\r\n  border: none;\r\n  border-radius: 14px;\r\n  padding: 16px 32px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 6px 20px rgba(26, 95, 63, 0.3);\r\n  margin-bottom: 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n}\r\n\r\n.loadMoreButton:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.4);\r\n}\r\n\r\n.loadMoreArrow {\r\n  font-size: 14px;\r\n}\r\n\r\n.loadMoreCount {\r\n  color: #64748b;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  background: rgba(26, 95, 63, 0.1);\r\n  padding: 8px 16px;\r\n  border-radius: 20px;\r\n  display: inline-block;\r\n}\r\n\r\n/* Responsive  */\r\n@media (max-width: 768px) {\r\n  .searchContainer {\r\n    padding: 15px;\r\n  }\r\n\r\n  .postsGrid {\r\n    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\r\n    gap: 16px;\r\n  }\r\n\r\n  .searchTitle {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .categoryTitle h2 {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .categoryHeader {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .loadMoreSection {\r\n    padding: 20px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .postsGrid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .searchTitle {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .categoryTitle {\r\n    flex-wrap: wrap;\r\n    gap: 8px;\r\n  }\r\n\r\n  .postImageContainer {\r\n    height: 140px;\r\n  }\r\n\r\n  .postContent {\r\n    padding: 16px;\r\n  }\r\n\r\n  .backButton {\r\n    width: 100%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .loadMoreButton {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchContainer": `SearchByCategpry_searchContainer__Tp1ml`,
	"loadingState": `SearchByCategpry_loadingState__n6OGo`,
	"spinner": `SearchByCategpry_spinner__twS8g`,
	"spin": `SearchByCategpry_spin__+hPwi`,
	"errorState": `SearchByCategpry_errorState__CNoV1`,
	"errorIcon": `SearchByCategpry_errorIcon__6NTib`,
	"retryButton": `SearchByCategpry_retryButton__P4GLJ`,
	"searchHeader": `SearchByCategpry_searchHeader__46dwL`,
	"backButton": `SearchByCategpry_backButton__7vTbh`,
	"backArrow": `SearchByCategpry_backArrow__59YAv`,
	"searchTitle": `SearchByCategpry_searchTitle__G2PDV`,
	"categoryName": `SearchByCategpry_categoryName__KfOQO`,
	"searchSubtitle": `SearchByCategpry_searchSubtitle__IPlvU`,
	"searchTerm": `SearchByCategpry_searchTerm__wfVY7`,
	"resultsCount": `SearchByCategpry_resultsCount__3Wf6y`,
	"noResults": `SearchByCategpry_noResults__UJRAW`,
	"noResultsIcon": `SearchByCategpry_noResultsIcon__fivxI`,
	"allCategoriesButton": `SearchByCategpry_allCategoriesButton__XojPH`,
	"resultsSection": `SearchByCategpry_resultsSection__FdKlU`,
	"categoryHeader": `SearchByCategpry_categoryHeader__wQzs8`,
	"categoryTitle": `SearchByCategpry_categoryTitle__3-vwG`,
	"categoryIcon": `SearchByCategpry_categoryIcon__8xS6q`,
	"categoryCount": `SearchByCategpry_categoryCount__2KB8l`,
	"postsGrid": `SearchByCategpry_postsGrid__kHktd`,
	"postCard": `SearchByCategpry_postCard__uBJQ9`,
	"postImageContainer": `SearchByCategpry_postImageContainer__dyvLv`,
	"postImage": `SearchByCategpry_postImage__suuht`,
	"postOverlay": `SearchByCategpry_postOverlay__5dliS`,
	"postIcon": `SearchByCategpry_postIcon__MzfQ0`,
	"postContent": `SearchByCategpry_postContent__tr+8q`,
	"postTitle": `SearchByCategpry_postTitle__CdDKm`,
	"postMeta": `SearchByCategpry_postMeta__L7ao4`,
	"postAuthor": `SearchByCategpry_postAuthor__jrrX2`,
	"metaSeparator": `SearchByCategpry_metaSeparator__k2F2i`,
	"postDate": `SearchByCategpry_postDate__UnsCU`,
	"postCategory": `SearchByCategpry_postCategory__GcPLl`,
	"categoryBadge": `SearchByCategpry_categoryBadge__auWHg`,
	"loadMoreSection": `SearchByCategpry_loadMoreSection__R5a-g`,
	"loadMoreButton": `SearchByCategpry_loadMoreButton__-1qLv`,
	"loadMoreArrow": `SearchByCategpry_loadMoreArrow__pC4Ku`,
	"loadMoreCount": `SearchByCategpry_loadMoreCount__8OXce`
};
export default ___CSS_LOADER_EXPORT___;
